import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PeopleStepsOneWrapper = styled.div`
  ${({ theme }) =>
    theme.currentStep === 1
      ? `
    width: 100%;
    min-height: calc(100svh - var(--navbar-height));

    display: flex;
    flex-direction: column;
    align-items: ${!theme.isLoading ? 'center' : 'flex-start'};
    justify-content: ${!theme.isLoading ? 'center' : 'flex-start'};
    gap: 55px;

    ${!theme.isLoading ? 'padding: 0px 40px;' : 'padding: 40px;'}

    ${BREAKPOINTS.tablet} {
      min-height: 100svh;
      padding: 0px 16px;
      justify-content: unset;

      gap: 32px;
    }

    position: relative;
  `
      : `
    width: calc(100% - 72px);
    align-self: center;

    ${BREAKPOINTS.tablet} {
      width: calc(100% - 32px);
    }
  `}
`;

export const PeopleStepsOneBackground = styled(motion.img).attrs({
  src: '/images/people/background-map.svg',
  exit: { opacity: 0 },
})`
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translate(-70%, -50%);

  width: 763px;
  height: 310px;

  object-fit: cover;
  mix-blend-mode: multiply;
`;

export const PeopleStepsOneContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: ${({ theme }) => (!theme.isLoading ? 'center' : 'flex-start')};
  justify-content: center;
  gap: 30px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
  }

  position: relative;
`;

export const PeopleStepsOneBox = styled.img.attrs({
  src: '/images/people/box.png',
})`
  width: 68px;
  height: 72px;
`;

export const PeopleStepsOneLeftContainer = styled.div`
  width: 100%;
  ${({ theme }) =>
    !theme.isLoading && theme.currentStep === 1
      ? 'max-width: 650px;'
      : `
    margin-top: 36px;
    max-width: 1440px;

    ${BREAKPOINTS.tablet} {
      margin-top: 0px;
    }
  `}

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 35px;

  ${BREAKPOINTS.large_tablet_landscape} {
    gap: 22px;
  }

  ${BREAKPOINTS.tablet} {
    gap: 16px;
  }

  position: relative;
`;

export const PeopleStepsOneTitle = styled.h5`
  font-weight: 400;
  font-size: 38px;
  line-height: 42px;

  ${BREAKPOINTS.large_tablet_landscape} {
    font-size: 32px;
    line-height: normal;
  }

  ${BREAKPOINTS.tablet} {
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }

  color: var(--color-text);
`;

export const PeopleStepsOneDescription = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;

  ${BREAKPOINTS.large_tablet_landscape} {
    font-size: 18px;
    line-height: normal;
  }

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }

  color: var(--color-text);
`;

export const PeopleStepsOneSpinnerContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;
